import React, { useMemo } from 'react';
import cn from 'classnames';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { useTranslation } from 'react-i18next';
import BrandedButton from '@wix/da-ds/pkg/Buttons/BrandedButton';
import { Url } from '@wix/da-url';

import s from './AnonPaginationBlocker.scss';

interface Props {
  className?: string;
  joinpoint: string;
  returnTo?: string;
  returnType?: string;
}

const AnonPaginationBlocker: React.FC<Props> = ({
  className,
  joinpoint,
  returnTo: suppliedReturnTo,
  returnType,
}) => {
  const { t } = useTranslation();

  const returnTo = useMemo(() => {
    if (suppliedReturnTo) {
      return suppliedReturnTo;
    }
    if (typeof window !== 'undefined') {
      return window.location.href;
    }
    return undefined;
  }, [suppliedReturnTo]);

  return (
    <Section className={cn(s['root'], className)}>
      <Heading className={s['heading']}>{t('pagination.anonBlocker.title')}</Heading>
      <p className={s['description']}>{t('pagination.anonBlocker.description')}</p>
      <BrandedButton
        variant="brand-green"
        size="large"
        href={Url.joinLink(joinpoint, returnTo, returnType)}
      >
        {t('pagination.anonBlocker.button.label')}
      </BrandedButton>
    </Section>
  );
};
AnonPaginationBlocker.displayName = 'AnonPaginationBlocker';

export default AnonPaginationBlocker;
